import { render } from "./OrderbookView.vue?vue&type=template&id=0ff04956&scoped=true"
import script from "./OrderbookView.vue?vue&type=script&lang=js"
export * from "./OrderbookView.vue?vue&type=script&lang=js"

import "./OrderbookView.vue?vue&type=style&index=0&id=0ff04956&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff04956"]])

export default __exports__